<template>
  <section>
    <boy-status-history-table :entity-id="memberID" type="rider" />
  </section>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import BoyStatusHistoryTable from '@/components/BoyStatus/BoyStatusHistoryTable'

export default defineComponent({
  name: 'MemberProfileBoyHistory',
  components: { BoyStatusHistoryTable },
  props: ['memberID']
})
</script>



// WEBPACK FOOTER //
// src/views/Members/Tabs/BOYHistory.vue